import React, { useEffect, useRef, Fragment } from 'react';
import { Transition } from '@headlessui/react';
import { XMarkIcon } from '@heroicons/react/24/outline';

const HelpPopover = ({ isOpen, onClose, content, isWide }) => {
  const popoverRef = useRef(null);

  useEffect(() => {
    const handleClickOutside = (event) => {
      if (popoverRef.current && !popoverRef.current.contains(event.target)) {
        onClose();
      }
    };

    if (isOpen) {
      document.addEventListener('mousedown', handleClickOutside);
    }

    return () => {
      document.removeEventListener('mousedown', handleClickOutside);
    };
  }, [isOpen, onClose]);

  return (
    <Transition
      show={isOpen}
      as={Fragment}
      enter="transform transition ease-out duration-300"
      enterFrom="scale-95 opacity-0"
      enterTo="scale-100 opacity-100"
      leave="transform transition ease-in duration-200"
      leaveFrom="scale-100 opacity-100"
      leaveTo="scale-95 opacity-0"
    >
      <div 
        ref={popoverRef}
        className="absolute right-0 top-full mt-2 origin-top-right"
        style={{ maxWidth: 'calc(100vw - 2rem)' }}
      >
        <div className={`bg-white rounded-lg shadow-lg ring-1 ring-black ring-opacity-5 p-4 ${isWide ? 'min-w-[400px]' : 'max-w-sm'}`}>
          <div className="flex justify-between items-start">
            <h3 className="text-base font-medium text-gray-900 mb-2">
              {content.title}
            </h3>
            <button
              onClick={onClose}
              className="ml-4 -mr-1 -mt-1 p-1 rounded-full text-gray-400 hover:text-gray-500 hover:bg-gray-100"
            >
              <XMarkIcon className="h-5 w-5" />
            </button>
          </div>
          <div className="space-y-2 text-sm text-gray-600">
            <p className="mb-2">{content.step1}</p>
            <p>{content.step2}</p>
          </div>
        </div>
      </div>
    </Transition>
  );
};

export default HelpPopover; 